import styled from 'styled-components';

export const StyledViewerWrapper = styled.div`
  position: relative;
  margin: 0 auto;
`;
